import React, { useRef } from "react"
import { useDispatch, useSelector } from "react-redux"
import {
  deselectAllQuestionColumns,
  deselectAllSubmissionDefaultColumns,
  deselectAllTaskDefaultColumns,
  deselectColumn,
  formQuestions,
  orderedColumns,
  selectAllQuestionColumns,
  selectAllSubmissionDefaultColumns,
  selectAllTaskDefaultColumns,
  selectColumn,
  submissionColumnOptions,
  taskColumnOptions,
} from "reduxSlices/taskReportBuilderSlice"
import SelectableOptions from "ReportBuilder/SelectableOptions"
import { DraggableColumnTypes } from "ReportBuilder/DragAndDrop/DraggableColumnTypes"
import ColumnOptionsSection from "./ColumnOptionsSection"

const ColumnOptions = () => {
  const dispatch = useDispatch()
  const ref = useRef(null)

  const selectedColumns = useSelector(orderedColumns)
  const submissionOptions = useSelector(submissionColumnOptions)
  const taskOptions = useSelector(taskColumnOptions)
  const questionOptions = useSelector(formQuestions)

  const selectOption = (column) => dispatch(selectColumn(column))
  const deselectOption = (column) => dispatch(deselectColumn(column))

  const selectAllSubmission = () => dispatch(selectAllSubmissionDefaultColumns())
  const deselectAllSubmission = () => dispatch(deselectAllSubmissionDefaultColumns())

  const selectAllTask = () => dispatch(selectAllTaskDefaultColumns())
  const deselectAllTask = () => dispatch(deselectAllTaskDefaultColumns())

  const selectAllQuestions = () => dispatch(selectAllQuestionColumns())
  const deselectAllQuestions = () => dispatch(deselectAllQuestionColumns())

  return (
    <SelectableOptions
      acceptableTypes={DraggableColumnTypes.TASK_REPORT_COLUMN_SELECTION}
      dropFunction={deselectOption}
      ref={ref}
    >
      <ColumnOptionsSection
        title="Submission Column Defaults"
        options={submissionOptions}
        selectedColumns={selectedColumns}
        selectOption={selectOption}
        deselectOption={deselectOption}
        selectAll={selectAllSubmission}
        deselectAll={deselectAllSubmission}
      />
      <ColumnOptionsSection
        title="Task Column Defaults"
        options={taskOptions}
        selectedColumns={selectedColumns}
        selectOption={selectOption}
        deselectOption={deselectOption}
        selectAll={selectAllTask}
        deselectAll={deselectAllTask}
      />
      <ColumnOptionsSection
        title="Task Form Questions"
        options={questionOptions}
        selectedColumns={selectedColumns}
        selectOption={selectOption}
        deselectOption={deselectOption}
        selectAll={selectAllQuestions}
        deselectAll={deselectAllQuestions}
      />
    </SelectableOptions>
  )
}

export default ColumnOptions
